export const ContactColumns = [
  // { key: 'sn', label: 'SN' },
  { key: 'action', label: 'Action' },
  // { key: 'status', label: 'Status' },
  { key: 'name', label: 'Name' },
  { key: 'office', label: 'Office' },
  { key: 'email', label: 'Email' },
  { key: 'phone', label: 'Phone' },
  { key: 'ext', label: 'Ext' },
  { key: 'cell', label: 'Cell' },
  { key: 'er', label: 'ER' },
  { key: 'or', label: 'OR' },
];
export const ContactMasterColumns = [
  // { key: 'sn', label: 'SN' },
  { key: 'action', label: 'Action' },
  // { key: 'status', label: 'Status' },
  { key: 'custId', label: 'Customer Id' },
  { key: 'custName', label: 'Customer' },
  { key: 'name', label: 'Name' },
  { key: 'office', label: 'Office' },
  { key: 'email', label: 'Email' },
  { key: 'phone', label: 'Phone' },
  { key: 'cell', label: 'Cell' },
];
